import React from 'react'
import PropTypes from 'prop-types'
import useIsDesktopSize from '../../utils/isDesktopHook';
import PubliftAd from '../../components/ads/publift-ad';

const AdColumn = ({ publiftAdId = null, side = `right`, isSticky = true }) => {
    const isDesktopSize = useIsDesktopSize();
    const columnClassList = [`column`, `column-${side}`];

    return (
        <div className={ columnClassList.join( ' ' ) }>
            {isDesktopSize && (
                <aside className={ `${isSticky ? `column-sticky` : ``}` }>
                    <PubliftAd adId={publiftAdId} />
                </aside>
            )}
        </div>
    )
}

AdColumn.propTypes = {
    publiftAdId: PropTypes.string,
    side: PropTypes.string,
    isSticky: PropTypes.bool,
}

export default AdColumn
